import React from "react";
import { Link, useLocation } from "react-router-dom";

/**
 * PublicTopMenuBar - Primary navigation bar for Public Experience Mode
 * Appears directly under the header on Public Library and Demo Player pages
 * Always visible (no hamburger required)
 * 
 * Desktop: Horizontal menu with all items visible
 * Mobile: Horizontal scrollable menu (3+ items visible)
 */
const PublicTopMenuBar = () => {
  const location = useLocation();

  const publicMenuItems = [
    { label: 'Welcome', path: '/' },
    { label: 'Public Library', path: '/public/library' },
    { label: 'Pricing', path: '/pricing' },
    { label: 'FAQ', path: '/faq' },
    { label: 'Contact', path: '/contact' },
    { label: 'About', path: '/about' }
  ];

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <nav className="sticky top-0 z-30 bg-slate-900/95 backdrop-blur-md border-b border-slate-800">
      <div className="mx-auto max-w-6xl">
        {/* Desktop & Mobile: Wrapping menu bar */}
        <div className="flex flex-wrap justify-center items-center px-3 py-2 gap-1.5 sm:gap-2">
          {publicMenuItems
            .filter(item => !isActive(item.path)) // Hide current page link
            .map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className="px-3 py-1.5 sm:px-4 sm:py-2 rounded-full text-xs sm:text-sm font-medium text-slate-300 hover:text-white hover:bg-slate-800 transition-all whitespace-nowrap"
              >
                {item.label}
              </Link>
            ))}
        </div>
      </div>
    </nav>
  );
};

export default PublicTopMenuBar;
